// File: client/src/components/rules/nodeConfigs/ErrorConfig.js
import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

const ErrorConfig = () => {
    return (
        <div>
            <Form.Item
                name="message"
                label="Error Message"
                rules={[{ required: true, message: 'Please enter an error message' }]}
            >
                <TextArea rows={3} placeholder="Enter error message" />
            </Form.Item>
        </div>
    );
};

export default ErrorConfig;
